import React from 'react';
import styled from 'styled-components';
import { ButtonPrimaryMedium } from '../Button/Button';

const ErrorHandlerWrap = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  text-align: center;
  .error-handler-title {
    font-size: ${({ theme }) => theme.fontSize05};
    color: ${({ theme }) => theme.colorText70};
    margin-bottom: ${({ theme }) => theme.spacing01};
  }

  .error-handler-description {
    color: ${({ theme }) => theme.colorText50};
    margin-bottom: ${({ theme }) => theme.spacing02};
  }
`;

export default function ErrorHandler({ title, description, onTryAgainClick, buttonText = 'Try again' }) {
  return (
    <ErrorHandlerWrap>
      <div>
        <div className="error-handler-title">{title}</div>
        <div className="error-handler-description">{description}</div>
        <ButtonPrimaryMedium onClick={onTryAgainClick}>{buttonText}</ButtonPrimaryMedium>
      </div>
    </ErrorHandlerWrap>
  );
}
